let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6MdFV")).then(() => parcelRequire('eLBbd'));